import {
  AutocompleteArrayInput,
  AutocompleteInput,
  ReferenceInput,
  required,
  useSimpleFormIteratorItem,
} from "react-admin";
import { useWatch } from "react-hook-form";
import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { CourseChoices } from "utils/choices";

const EligibilityIteratorItem = ({ mfStructuralUnitId }) => {
  const { index } = useSimpleFormIteratorItem();
  const electiveCourseSpecialities = useWatch({ name: "electiveCourseSpecialities" });

  const excludeSpecialityIds = electiveCourseSpecialities
    ?.filter((_, i) => i !== index)
    ?.map(row => row?.specialityId)
    ?.filter(Boolean);

  const specialityFilter = {
    ...(mfStructuralUnitId ? { StructuralUnitId: mfStructuralUnitId } : {}),
    ...(excludeSpecialityIds?.length ? { ExcludeIds: excludeSpecialityIds } : {}),
  };

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="specialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
          filter={specialityFilter}
        >
          <AutocompleteInput
            label="Специалност"
            optionText="name"
            fullWidth
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <AutocompleteArrayInput
          source="courses"
          label="Курсове"
          choices={CourseChoices}
          fullWidth
          validate={required()}
          format={value => value?.map(v => v?.course) ?? []}
          parse={value => value?.map(course => ({ course })) ?? []}
        />
      </Grid>
    </Grid>
  );
};

export default EligibilityIteratorItem;
